import { ReportTop as WebReport1 } from "@/components/report/ReportTop";
import { ReportPageBaseProps, TopResponse } from "@/components/report/types";
import { useAxios } from "@/utils/axios";
import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import WebReport2, { WebReport2Data } from "./WebReport2";


type ReportPageProps = ReportPageBaseProps & {
  indicator: boolean;
};

function WebReport({
  data,
  uuid,
}: {
  data: { publish_version: string };
  uuid: string;
}) {
  const version = data.publish_version;

  switch (version) {
    case "1.0": // PDF レポートのため、対象外
    case "1.1":
      return <></>;

    case "2.0": // 初期 Webレポート
    case "3.0":
    case "3.1":
      return <WebReport1 data={data as TopResponse} uuid={uuid} />;

    default: // 改善版 Webレポート
      return <WebReport2 uuid={uuid} data={data as WebReport2Data} />;
  }
}

export function ReportPage({ indicator, setIndicator }: ReportPageProps) {
  const { uuid } = useParams();
  const axios = useAxios();
  const [isPdf, setPdf] = useState(false);
  const [data, setData] = useState<{ publish_version: string }>();

  useEffect(() => {
    (async () => {
      const response = await axios.get(`/api/report/${uuid}/`, {
        responseType: "arraybuffer",
      });
      const type = response.headers["content-type"];
      setPdf(type === "application/pdf");
      if (type === "application/pdf") {
        window.location.href = URL.createObjectURL(
          new Blob([response.data], { type })
        );
        setIndicator(false);
      } else if (type === "application/json") {
        setData(JSON.parse(new TextDecoder().decode(response.data)));
        setIndicator(false);
      }
    })();
  }, [axios, uuid, setIndicator]);

  if (uuid == null) return <></>;
  return (
    <>
      {!indicator && isPdf && (
        <Stack
          sx={{
            display: "flex",
            alignItems: "center",
            height: "calc(100vh - 207px)",
            justifyContent: "center",
          }}
        >
          <Typography variant="body1">
            レポートのダウンロードが完了しました。
            <br />
            ダウンロードフォルダをご確認ください。
          </Typography>
        </Stack>
      )}
      {!indicator && !isPdf && data != null && (
        <WebReport data={data} uuid={uuid} />
      )}
    </>
  );
}
